import React, { useState, useEffect, useCallback } from 'react';
import { Popover, Typography, Box, Grid, Avatar } from '@mui/material';
import styles from "./notification.module.css";
import { useSelector } from "react-redux";
import ModalCloseButton from "../../components/UI/ModalCloseButton";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import useSocketHook from "../../utils/lib/socket"

export default function RealTimeNotificationModal({ setOpenAuthentication, setOpenedAccount, setNotificationData, setDot, notificationData }) {
    const axios = useAxiosPrivate();
    const socket = useSocketHook();
    const [open, setOpen] = useState(false);
    const profilePic = useSelector((state) => state.auth.url);
    const role = useSelector((state) => state.auth.role);
    const [realTimeData, setRealTimeData] = useState(null);

    const handleClose = () => setOpen(false);

    const loadNotificationData = useCallback(async () => {
        try {
            const { data } = await axios.get("/notifications/list");
            setNotificationData(data.data);
            setDot(true);
        } catch (error) {
            console.log(error);
        }
    }, [axios, setNotificationData, setDot]);

    useEffect(() => {
        if (!socket || !socket.connected) {
            console.log('Socket not ready, skipping event setup');
            return;
        }

        console.log('Setting up notification listener');

        const handleMessage = (data) => {
            console.log('Real-time notification received:', data);
            setRealTimeData(data);
            loadNotificationData(); // now safe
            setOpen(true);
            setTimeout(() => setOpen(false), 6000);
        };

        socket.on("message", handleMessage);

        return () => {
            if (socket) {
                console.log('Cleaning up notification listener');
                socket.off("message", handleMessage);
            }
        };
    }, [socket, role, loadNotificationData]);

    const handleVerify = async (e) => {
        try {
            await axios.get(`/actions/complete/${e?.data?.request_id}`);
            const notification = await notificationData.filter((item) => item?.data?.request_id === e?.data?.request_id)
            await axios.get(`/notifications/mark_as_seen/${notification[0]?.id}`);
            setOpenAuthentication(true)
            const { data } = await axios.get("/notifications/list");
            setNotificationData(data.data)
            setDot(false)
        } catch (error) {
            console.log(error);
        }
        setOpen(false)
    };

    const handleReview = async (e) => {
        try {
            const notification = await notificationData.filter((item) => item?.data?.request_id === e?.data?.request_id)
            await axios.get(`/notifications/mark_as_seen/${notification[0]?.id}`);
            setOpenedAccount(true)
            const { data } = await axios.get("/notifications/list");
            setNotificationData(data.data)
            setDot(false)
        } catch (error) {
            console.log(error);
        }
        setOpen(false)
    };

    const id = open ? 'simple-popover' : undefined;

    return (
        <div>
            <Popover
                id={id}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Box className={styles.boxCSS}>
                    <Box className={styles.boxCSSRealTime}>
                        <Grid container>
                            <Grid item md={12}>
                                <Grid item md={12} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
                                    <ModalCloseButton onClick={handleClose} style={{ position: "static" }} />
                                </Grid>
                                <Grid item md={12} style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "-0.5rem", marginBottom: "0.5rem" }}>
                                    <Typography sx={{ fontFamily: "Poppins", fontStyle: "normal", fontWeight: "600", fontSize: "15px", color: "#000000" }} className={styles.notificationHeader}>Notification</Typography>
                                </Grid>
                                <Grid item md={12}>
                                    <Grid container sx={{ marginBottom: "1rem" }}>
                                        <Grid item md={2} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <Avatar
                                                alt="Remy Sharp"
                                                src={profilePic}
                                                sx={{ width: 35, height: 35 }}
                                            />
                                        </Grid>
                                        <Grid item md={10} >
                                            {role === "COACH" ?
                                                <Typography sx={{ p: 2, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "500", fontSize: "13.5px", color: "#000000" }}>{realTimeData?.message}<span style={{ color: "#0F9BB0", textDecorationLine: 'underline', cursor: "pointer" }} onClick={() => handleVerify(realTimeData)}>{realTimeData?.data?.status !== 'DECLINED' ? "Verify Now" : null}</span></Typography>
                                                : <Typography sx={{ p: 2, fontFamily: "Poppins", fontStyle: "normal", fontWeight: "500", fontSize: "13.5px", color: "#000000" }}>{realTimeData?.message}<span style={{ color: "#0F9BB0", textDecorationLine: 'underline', cursor: "pointer" }} onClick={() => handleReview(realTimeData)}>Review</span></Typography>
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Popover>
        </div>
    );
}